import { ComponentType } from '@angular/cdk/overlay';
import {
  InjectionToken,
  Signal,
} from '@angular/core';
import { IErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ErrorInterceptorOptions } from './error-interceptor-options';

export const EUROGARD_ERROR_DIALOG_DATA = new InjectionToken<Signal<any[]>>('eurogard/error/dialog-data');

export const EUROGARD_ERROR_DIALOG_ERROR = new InjectionToken<any>('eurogard/error/dialog-error');

export const EUROGARD_ERROR_DIALOG_COMPONENT = new InjectionToken<ComponentType<IErrorDialogComponent>>('eurogard/error/dialog-component');

export const EUROGARD_ERROR_INTERCEPTOR_OPTIONS = new InjectionToken<ErrorInterceptorOptions>('eurogard/error/interceptor-options');
